import { useTranslation } from 'react-i18next';
import { ON_STAGING_COLOR, STAGING_COLOR } from '@/pwa/web-manifest';
import { currentEnvironment } from './environment';

/**
 * The orange mark of staging on every page, sign-in included (the Director, 2026-10-05, #303): a
 * stripe along the top edge and a tab that says it. Fixed and click-through, so it never moves the
 * layout or hides a control under a click; drawn only in a staging build.
 */
export function StagingBar({ environment = currentEnvironment() }: { environment?: string }) {
  const { t } = useTranslation('shell');
  if (environment !== 'staging') {
    return null;
  }
  return (
    <div
      data-testid="staging-bar"
      className="pointer-events-none fixed inset-x-0 top-0 z-[100] flex justify-center"
    >
      <div className="absolute inset-x-0 top-0 h-1" style={{ background: STAGING_COLOR }} />
      {/* `staging-tab`: on a phone, inside the shell, the header carries the word instead and this
          tab is hidden (`shell.css`, #353): a floating tab covered the drawer's header and the
          content scrolling under it. The stripe stays, and the sign-in page keeps the tab. */}
      <p
        className="staging-tab relative m-0 rounded-b-md px-3 py-0.5 text-xs font-semibold"
        style={{ background: STAGING_COLOR, color: ON_STAGING_COLOR }}
      >
        {t('env.stagingBar')}
      </p>
    </div>
  );
}

/**
 * Staging's mark in the phone top bar (#353): in the bar itself rather than floating over the page,
 * as Stripe marks test mode in its header. `shell.css` shows it below 620px only; wider, the tab
 * above has room in the frame margin. Drawn only in a staging build.
 */
export function StagingChip({ environment = currentEnvironment() }: { environment?: string }) {
  const { t } = useTranslation('shell');
  if (environment !== 'staging') {
    return null;
  }
  return <span className="shell-staging-chip">{t('env.staging')}</span>;
}
